// extracted by mini-css-extract-plugin
export default {"fallback":"AsyncLoad_fallback__f1kSI","center":"AsyncLoad_center__ShduJ"};